<p-dialog [(visible)]="visible" [showHeader]="false" [modal]="true">
    <div class="wrapper">
        <div class="modal-header">
            <h4 class="modal-title"><strong>Anmeldung nicht möglich</strong></h4>
        </div>
        <div class="modal-body">
            <p>
                Wir haben festgestellt, dass Sie zu einem weiteren Lehrgang im gleichen Kalenderjahr bereits angemeldet
                sind.
                Sollte es sich bei der existierenden Anmeldung um einen bevorstehenden Lehrgangstermin handeln,
                so ersuchen wir Sie, die existierende Anmeldung zuvor zu stornieren, bevor Sie eine erneute Anmeldung
                vornehmen.
                Falls der Lehrgangstermin jedoch schon statt gefunden hat, würden wir uns freuen, Sie frühestens in
                einem Folgejahr begrüßen zu dürfen.
            </p>
            <br/>
            <p>Zu welchem Lehrgang Sie bereits angemeldet sind, können Sie unter
                <a href="/zertifizierungsverlauf">Zertifizierungsverlauf</a>
                einsehen.</p>
            <br/>
            <p>Falls Sie dennoch Fragen haben, nehmen Sie bitte mit uns <a href="/anmeldung">Kontakt</a>
                auf.</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default btn-success" (click)="closeOverlay()">Ich habe verstanden
            </button>
        </div>
    </div>
</p-dialog>
